<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">

  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-newton-cradle" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
  </ngx-spinner>

  <div class="row mx-auto">

    <div class="card card-primary card-outline">

      <!-- <div class="right-panel" [ngClass]="{ 'hidden': isHidden }" id="rightPanel">
        <ul>
          <li><a href="#">Menu Item 1</a></li>
          <li><a href="#">Menu Item 2</a></li>
          <li><a href="#">Menu Item 3</a></li>
        </ul>
      </div> -->

      <div class="card-header">
        <span class="card-title text-primary headText2"><i class="fas fa-map-marked-alt"></i>
          แผนที่แปลงอ้อย</span>
        <div class="card-tools text-primary ">

          <button (click)="togglePanel()" type="button" class="btn btn-tool" title="Contacts"
            data-widget="chat-pane-toggle">
            <i class="fas fa-filter"></i>
          </button>
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
          <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i>
          </button>
        </div>
      </div>
      <div class="card-body">

        <div class="row">
          <div class="col-md-9">
            <div id="map"></div>
          </div>
          <div class="col-md-3">

            <!-- DIRECT CHAT -->
            <div class="card direct-chat direct-chat-warning">
              <div class="card-header">
                <h3 class="card-title">ตัวเลือก</h3>

                <div class="card-tools">
                  <!-- <span title="3 New Messages" class="badge badge-warning">3</span> -->
                  <button type="button" class="btn btn-tool" title="Contacts" data-widget="chat-pane-toggle">
                    <i class="fas fa-filter"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                  <!-- <button type="button" class="btn btn-tool" data-card-widget="remove">
                    <i class="fas fa-times"></i>
                  </button> -->
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <div class="container">
                  <ul class="list-group list-group-unbordered mb-3">
                    <li class="list-group-item">
                      <b>จำนวนแปลงทั้งสิ้น</b> <a class="float-right"><b class="w3-large ggPrompt">{{ cntAllPlot | number
                          }}</b> </a>
                    </li>
                    <li class="list-group-item">
                      <b>แปลงตามการเลือก</b> <a class="float-right"> <b class="w3-large ggPrompt">{{ cntFilterPlot | number
                          }}</b></a>
                    </li>
                    <li class="list-group-item">
                      <b>พื้นที่(ไร่)</b> <a class="float-right"> <b class="w3-large ggPrompt">{{ areaFilterPlot | number
                          }}</b></a>
                    </li>
                    <li class="list-group-item">
                      <b>ปริมาณอ้อย(ตัน)</b> <a class="float-right"> <b class="w3-large ggPrompt">{{ canevalueFilterPlot |
                          number }}</b></a>
                    </li>
                    <li class="list-group-item">
                      <b>ปริมาณอ้อย(ตัน)</b> <a class="float-right"> <b class="w3-large ggPrompt">{{ canevalueFilterPlot |
                          number }}</b></a>
                    </li>
                    <li class="list-group-item">
                      <b>ปริมาณอ้อย(ตัน)</b> <a class="float-right"> <b class="w3-large ggPrompt">{{ canevalueFilterPlot |
                          number }}</b></a>
                    </li>
                    <li class="list-group-item">
                      <b>ปริมาณอ้อย(ตัน)</b> <a class="float-right"> <b class="w3-large ggPrompt">{{ canevalueFilterPlot |
                          number }}</b></a>
                    </li>
                    <li class="list-group-item">
                      <b>ปริมาณอ้อย(ตัน)</b> <a class="float-right"> <b class="w3-large ggPrompt">{{ canevalueFilterPlot |
                          number }}</b></a>
                    </li>
                    <li class="list-group-item">
                      <b>ปริมาณอ้อย(ตัน)</b> <a class="float-right"> <b class="w3-large ggPrompt">{{ canevalueFilterPlot |
                          number }}</b></a>
                    </li>
                  </ul>
                </div>

                <!-- Contacts are loaded here -->
                <div class="direct-chat-contacts w3-sand">

                  <div class="container">
                    <p> รัศมี</p>
                    <div class="form-group">
                      <select (change)="setCircle($event)" class="form-control select2" style="width: 100%;">
                        <option value="40000" selected="selected">40 กม.</option>
                        <option value="10000">10 กม.</option>
                        <option value="20000">20 กม.</option>
                        <option value="30000">30 กม.</option>
                        <option value="40000">40 กม.</option>
                        <option value="50000">50 กม.</option>
                      </select>
                    </div>
                    <p> เลือกขอบเขต</p>
                    <div class="form-group">
                      <select (change)="setMapZone($event)" class="form-control select2" style="width: 100%;">
                        <option value="01">โซน 01</option>
                        <option value="02">โซน 02</option>
                        <option value="03">โซน 03</option>
                        <option value="04">โซน 04</option>
                        <option value="05">โซน 05</option>
                        <option value="06.1">โซน 06.1</option>
                        <option value="06.2">โซน 06.2</option>
                        <option value="07.1">โซน 07.1</option>
                        <option value="07.2">โซน 07.2</option>
                        <option value="08.1">โซน 08.1</option>
                        <option value="08.2">โซน 08.2</option>
                        <option value="09">โซน 09</option>
                        <option value="10.1">โซน 10.1</option>
                        <option value="10.2">โซน 10.2</option>
                        <option value="0">ทุกโซน</option>
                        <option value="P1">ส่วน1</option>
                        <option value="P2">ส่วน2</option>
                        <option value="P3">ส่วน3</option>
                        <option value="P4">ส่วน4</option>
                      </select>
                    </div>
                  </div>
                  <!-- /.contacts-list -->
                </div>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                <form action="#" method="post">
                  <div class="input-group">
                    <input type="text" name="message" placeholder="Type Message ..." class="form-control">
                    <span class="input-group-append">
                      <button type="button" class="btn btn-warning">Send</button>
                    </span>
                  </div>
                </form>
              </div>
              <!-- /.card-footer-->
            </div>
            <!--/.direct-chat -->

          </div>
        </div>
      </div>
      <div class="card-footer">
        <p> Footer </p>
      </div>
    </div>

  </div>
</div>

<app-footer></app-footer>